// extracted by mini-css-extract-plugin
export default {"tag-wrapper":"Tag_tag-wrapper__wjdR+","grey":"Tag_grey__0VLIY","mint":"Tag_mint__w60YZ","salmon":"Tag_salmon__KoM+7"};